import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl-next';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { FieldBase } from '@atlassian/help-center-common-component/fields/field-base';
import type { FieldFormProps, AttachmentFile } from '@atlassian/help-center-common-component/fields/types';
import i18n from './messages';

export interface Props extends FieldFormProps<AttachmentFile[]> {
    mediaApiError?: string;
}

const RequestCreateAttachmentFieldError: React.FunctionComponent<Props> = ({
    label,
    description,
    required,
    errorMessage,
    mediaApiError,
    id,
}) => {
    return (
        <FieldBase htmlFor={id} label={label} description={description} required={required} errorMessage={errorMessage}>
            <Error>{mediaApiError || <FormattedMessage {...i18n.genericError} />}</Error>
        </FieldBase>
    );
};

export default RequestCreateAttachmentFieldError;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Error = styled.div`
    ${mixins.borderRadius};
    border: 1px solid ${token('color.border.danger', colors.R500)};
    width: 100%;
    padding: ${token('space.100', '8px')};
    text-align: center;
`;
